// Tier-1 target language list for the Course Matrix's Target selector, plus the country
// display names used by its Country selector. `native` is the target's home-market country
// code — it's always offered as a Country option alongside US/GB/AU (deduplicated).
export interface TargetLanguage {
  code: string;
  name: string;
  native: string;
}

export const TARGET_LANGUAGES: TargetLanguage[] = [
  { code: 'spa', name: 'Spanish', native: 'ES' },
  { code: 'cmn', name: 'Mandarin', native: 'TW' },
  { code: 'fra', name: 'French', native: 'FR' },
  { code: 'deu', name: 'German', native: 'DE' },
  { code: 'jpn', name: 'Japanese', native: 'JP' },
  { code: 'kor', name: 'Korean', native: 'KR' },
  { code: 'por', name: 'Portuguese', native: 'BR' },
  { code: 'rus', name: 'Russian', native: 'RU' },
  { code: 'ara', name: 'Arabic', native: 'SA' },
  { code: 'hin', name: 'Hindi', native: 'IN' },
  { code: 'ita', name: 'Italian', native: 'IT' },
  { code: 'ell', name: 'Greek', native: 'GR' },
  { code: 'heb', name: 'Hebrew', native: 'IL' },
  { code: 'tur', name: 'Turkish', native: 'TR' },
  { code: 'vie', name: 'Vietnamese', native: 'VN' },
  { code: 'ind', name: 'Indonesian', native: 'ID' },
  { code: 'tha', name: 'Thai', native: 'TH' },
  { code: 'nld', name: 'Dutch', native: 'NL' },
  { code: 'pol', name: 'Polish', native: 'PL' },
];

export const COUNTRY_NAMES: Record<string, string> = {
  US: 'United States',
  GB: 'United Kingdom',
  AU: 'Australia',
  ES: 'Spain',
  TW: 'Taiwan',
  FR: 'France',
  DE: 'Germany',
  JP: 'Japan',
  KR: 'Korea',
  BR: 'Brazil',
  RU: 'Russia',
  SA: 'Saudi Arabia',
  IN: 'India',
  IT: 'Italy',
  GR: 'Greece',
  IL: 'Israel',
  TR: 'Turkey',
  VN: 'Vietnam',
  ID: 'Indonesia',
  TH: 'Thailand',
  NL: 'Netherlands',
  PL: 'Poland',
};

export function targetLanguageName(code: string): string {
  return TARGET_LANGUAGES.find((t) => t.code === code)?.name ?? code.toUpperCase();
}
